'use strict';

/* globals define, ajaxify, $, socket, app, utils, config */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/memoryGame/memory-game-editor', [
	config.relative_path + '/plugins/nodebb-plugin-memory-game/static/vendor/vue.js',
	'translator',
	'benchpress',
	'gameCreator',
	'coverPhoto',
	'pictureCropper',
	'slugify',
	'bootbox',
], function (vue, translator, Benchpress, gameCreator, coverPhoto, pictureCropper, slugify, bootbox) {
	var	MemoryGameEditor = {};

	var uploadingData = {
		onStart: function () {},
		onEnd: function () {},
		onProgress: function () {},
	};

	MemoryGameEditor.init = function () {
		gameCreator.init(ajaxify.data.game, ajaxify.data.translations);

		addActions();
	};

	function addActions() {
		var actions = {
			update: updateGame,
			delete: deleteGame,
		};

		for (var key in actions) {
			if (actions.hasOwnProperty(key)) {
				$('[data-action="' + key + '"]').click(actions[key]);
			}
		}

		addUploadAction();
	}

	function updateGame() {
		applyFormValues();

		var data = $.extend({}, ajaxify.data.game, { images: getParsedImages() });

		socket.emit('plugins.memoryGames.updateMemoryGame', data, function (err) {
			if (err) {
				return app.alertError(err.message);
			}

			app.alert({
				alert_id: 'game_edited',
				message: '[[memory_game:game-edited]]',
				type: 'success',
				timeout: 2000,
			});

			ajaxify.go('memory-games/' + ajaxify.data.game.gameId + '/' + slugify(data.title));
		});
	}

	function getParsedImages() {
		var images = [];

		for (var imageIndex = 0; imageIndex < ajaxify.data.game.images.length; imageIndex++) {
			var image = ajaxify.data.game.images[imageIndex];

			images.push({
				url: image.url,
			});
		}

		return images;
	}

	function applyFormValues() {
		ajaxify.data.game.description = $('#description').val();
		ajaxify.data.game.title = $('#title').val();
	}

	function deleteGame() {
		bootbox.confirm('Do you want to delete memory game?', function (confirm) {
			if (!confirm) {
				return;
			}

			socket.emit('plugins.memoryGames.removeMemoryGame', {
				gameId: ajaxify.data.game.gameId,
			}, function (err) {
				if (err) {
					return app.alertError(err.message);
				}

				app.alert({
					alert_id: 'game_removed',
					message: '[[memory_game:game-removed]]',
					type: 'success',
					timeout: 2000,
				});

				ajaxify.go('memory-games');
			});
		});
	}

	function addUploadAction() {
		$('#contentFileForm #files').on('change', function (e) {
			var files = (e.target || {}).files || ($(this).val() ? [{ name: $(this).val(), type: utils.fileMimeType($(this).val()) }] : null);

			if (files) {
				uploadFile({
					files: files,
					route: '/api/post/upload',
					filename: $(this).val().replace(/^.*[\\/]/, ''),
				});
			}
		});
	}

	function uploadFile(params) {
		var filesForm = $('#contentFileForm');

		filesForm.attr('action', config.relative_path + params.route);

		filesForm.off('submit').submit(function () {
			uploadingData.onStart();

			$(this).ajaxSubmit({
				headers: {
					'x-csrf-token': config.csrf_token,
				},
				resetForm: true,
				clearForm: true,
				formData: params.formData,
				data: { },

				error: function (xhr) {
					app.alertError(xhr.responseJSON.error);
				},

				uploadProgress: function (event, position, total, percent) {
					uploadingData.onProgress(percent);
				},

				success: function (uploads) {
					uploadingData.onEnd(uploads.response.images[0] || {});
				},

				complete: function () {

				},
			});

			return false;
		});

		filesForm.submit();
	}

	return MemoryGameEditor;
});
